<script>
export default {
  created: function() {
    window.location.href = `/${document.documentElement.lang}/404/`
  }
}
</script>
